(($, Drupal) => {
  Drupal.behaviors.textLinkButton = {
    attach: function attach() {
      $('.text-link').once('add').each(function (index) {
        const el = this;
        const detailsContainer = el.querySelector('.text-link__details');
        const detailsButton = el.querySelector('.text-link__details-button');
        const descWrapper = el.querySelector('.text-link__desc--hiden');
        const MAX_HEIGHT_BLOCK = 292;

        if (!detailsButton || !descWrapper) {
          detailsContainer.style.display = 'none';

          return false;
        }

        const descFullHeight = descWrapper.scrollHeight;
        const trueValue = descFullHeight > MAX_HEIGHT_BLOCK;

        detailsContainer.style.display = trueValue ? 'block' : 'none';

        if (trueValue) {
          detailsButton.addEventListener('click', () => {
            descWrapper.classList.add('text-link__desc--open');
            detailsContainer.style.display = 'none';
          });
        }
      });
    },
  };
})(jQuery, Drupal);
